import React from 'react'

import './shopping-cart-float-button.scss'

import iconImage from '../../../assets//images/shopping-cart-float-button.png'

import pushEventDataLayer from '../../../utils/pushEventDataLayer'

const ShoppingCartFloatButton = () => {
  return (
    <a
      className="f-shopping-cart-float-button "
      href="#buy"
      onClick={() => {
        pushEventDataLayer(
          'Interacciones - Carrito',
          'yogo-yogo',
          'click',
          'Carrito'
        )
      }}
    >
      <img src={iconImage} className="f-shopping-cart-float-button__img" />
    </a>
  )
}

export default ShoppingCartFloatButton
